import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { Component, Emit, PropSync, Vue } from 'vue-property-decorator';
import { EntryApi, } from "@/apis";
import { loadStripe } from '@stripe/stripe-js/pure';
import { DATETIME_FORMAT, PAYMENT_STATUS_CONST, RESULT_CODE_CONST, ENTRY_DEADLINE_OVER_MESSAGE } from "@/constants/constants";
import { format, parseISO } from "date-fns";
var PaymentCard = /** @class */ (function (_super) {
    __extends(PaymentCard, _super);
    function PaymentCard() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /** モーダル表示 */
        _this.isModalOpen = false;
        _this.stripe = null;
        _this.elements = null;
        _this.card = null;
        _this.cardError = '';
        _this.state = {
            cardNumber: false,
            expiry: false,
            cardCvc: false
        };
        _this.stripePublicKey = null;
        _this.processing = false;
        return _this;
    }
    Object.defineProperty(PaymentCard.prototype, "refs", {
        get: function () {
            return this.$refs;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaymentCard.prototype, "getPlaceName", {
        get: function () {
            if (this.syncedTarget) {
                return this.syncedTarget.placeName;
            }
            else {
                return '';
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaymentCard.prototype, "getPrice", {
        get: function () {
            if (this.syncedTarget && this.syncedTarget.totalAmount) {
                return new Intl.NumberFormat('ja-JP').format(this.syncedTarget.totalAmount) + " \u5186";
            }
            else {
                return '';
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaymentCard.prototype, "getStartDate", {
        get: function () {
            if (this.syncedTarget.startDateTime) {
                return "" + format(parseISO(this.syncedTarget.startDateTime), DATETIME_FORMAT.YYYYMMDD_HHMM_JP);
            }
            else {
                return '';
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaymentCard.prototype, "validationRules", {
        get: function () {
            return {};
        },
        enumerable: false,
        configurable: true
    });
    PaymentCard.prototype.mounted = function () {
        return __awaiter(this, void 0, void 0, function () {
            var corporate, stripeTestMode;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        corporate = this.$store.state.corporate;
                        if (corporate) {
                            stripeTestMode = process.env.VUE_APP_STRIPE_TEST_MODE;
                            if (stripeTestMode === 'live' && corporate.stripePublicKeyLive) {
                                this.stripePublicKey = corporate.stripePublicKeyLive;
                            }
                            else if (corporate.stripePublicKeyTest) {
                                this.stripePublicKey = corporate.stripePublicKeyTest;
                            }
                        }
                        if (!this.stripePublicKey) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.mountStripe()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    PaymentCard.prototype.validateForm = function () {
        if (!this.$refs.entryForm.validate()) {
            alert('validation error');
            return;
        }
        this.save();
    };
    PaymentCard.prototype.mountStripe = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, style, cardExpiry, cardCvc;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        // @ts-ignore
                        _a = this;
                        return [4 /*yield*/, loadStripe(this.stripePublicKey)];
                    case 1:
                        // @ts-ignore
                        _a.stripe = _b.sent();
                        if (this.stripe) {
                            this.elements = this.stripe.elements();
                            style = {
                                base: {
                                    fontSize: '14px',
                                    fontFamily: '"Roboto", sans-serif'
                                }
                            };
                            this.card = this.elements.create('cardNumber', { style: style });
                            this.card.mount('#card-number');
                            this.card.on('change', function (res) {
                                _this.cardError = res && res.error ? res.error.message || '' : '';
                                _this.state.cardNumber = res.complete;
                            });
                            cardExpiry = this.elements.create('cardExpiry', { style: style });
                            cardExpiry.mount('#card-expiry');
                            cardExpiry.addEventListener('change', function (res) {
                                _this.cardError = res && res.error ? res.error.message || '' : '';
                                _this.state.expiry = res.complete;
                            });
                            cardCvc = this.elements.create('cardCvc', { style: style });
                            cardCvc.mount('#card-cvc');
                            cardCvc.addEventListener('change', function (res) {
                                _this.cardError = res && res.error ? res.error.message || '' : '';
                                _this.state.cardCvc = res.complete;
                            });
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    PaymentCard.prototype.confirmPayment = function (clientSecret) {
        return __awaiter(this, void 0, void 0, function () {
            var paymentMethodID, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        paymentMethodID = null;
                        if (!this.stripe) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.stripe.confirmCardPayment(clientSecret, {
                                // eslint-disable-next-line @typescript-eslint/camelcase
                                payment_method: {
                                    card: this.card
                                }
                            })];
                    case 1:
                        res = _a.sent();
                        if (res.error) {
                            console.log("\u652F\u6255\u3044\u30A8\u30E9\u30FC\uFF1A" + res.error); // 支払いエラー
                        }
                        else if (res.paymentIntent) {
                            console.log("\u652F\u6255\u5B8C\u4E86\uFF1A" + res.paymentIntent.status + " PaymentMethodID: " + res.paymentIntent.payment_method);
                            paymentMethodID = res.paymentIntent.payment_method;
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        console.log("Stripe\u304C\u8A2D\u5B9A\u3055\u308C\u3066\u3044\u307E\u305B\u3093");
                        _a.label = 3;
                    case 3: return [2 /*return*/, paymentMethodID];
                }
            });
        });
    };
    // Customer登録（ログイン済みユーザのみ？）
    // async createStripeCustomer(paymentMethodID : string): Promise<string | undefined> {
    //   const res = await new StripeApi().createStripeCustomer({
    //     body: {
    //       email: this.entry.email,
    //       name: this.entry.name,
    //       phone: this.entry.tel,
    //       paymentMethodID: paymentMethodID,
    //       defaultPaymentMethodID: paymentMethodID
    //     }
    //   })
    //   const customerID = res.data.id
    //   console.log(customerID)
    //   return customerID
    // }
    // @Emit('paid')
    PaymentCard.prototype.save = function () {
        return __awaiter(this, void 0, void 0, function () {
            var createdEntry, paymentMethodID, payment;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log("save start");
                        return [4 /*yield*/, new EntryApi().createEntry({
                                body: this.syncedTarget
                            }).then(function (res) { return res.data; })];
                    case 1:
                        createdEntry = _a.sent();
                        if (!createdEntry) {
                            console.log("Entry\u306E\u767B\u9332\u306B\u5931\u6557\u3057\u307E\u3057\u305F");
                            return [2 /*return*/, null];
                        }
                        if (createdEntry.resultCode === RESULT_CODE_CONST.ENTRY_DEADLINE_OVER) {
                            // 予約受付期限切れ（画面を開いたまま日付をまたいだ場合など）
                            alert(ENTRY_DEADLINE_OVER_MESSAGE);
                            return [2 /*return*/, null];
                        }
                        if (!createdEntry.clientSecret) {
                            console.log("Client Secret\u304C\u3042\u308A\u307E\u305B\u3093");
                            return [2 /*return*/, null];
                        }
                        return [4 /*yield*/, this.confirmPayment(createdEntry.clientSecret)];
                    case 2:
                        paymentMethodID = _a.sent();
                        if (!paymentMethodID) {
                            alert("\u652F\u6255\u3044\u306B\u5931\u6557\u3057\u307E\u3057\u305F");
                            return [2 /*return*/];
                        }
                        createdEntry.paymentStatus = PAYMENT_STATUS_CONST.PAID;
                        if (!createdEntry.paymentList) {
                            createdEntry.paymentList = [];
                        }
                        payment = {
                            amount: createdEntry.totalAmount,
                            stripePaymentID: paymentMethodID,
                            paymentDateTime: format(new Date(), DATETIME_FORMAT.FOR_API)
                        };
                        createdEntry.paymentList.push(payment);
                        return [4 /*yield*/, new EntryApi().updateEntry({
                                id: createdEntry.id,
                                body: createdEntry
                            })];
                    case 3:
                        _a.sent();
                        this.isModalOpen = true;
                        return [2 /*return*/];
                }
            });
        });
    };
    PaymentCard.prototype.goCalendar = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, 'cal'];
            });
        });
    };
    PaymentCard.prototype.cancel = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, 'cal'];
            });
        });
    };
    __decorate([
        PropSync('target', { type: Object })
    ], PaymentCard.prototype, "syncedTarget", void 0);
    __decorate([
        Emit('paid')
    ], PaymentCard.prototype, "goCalendar", null);
    __decorate([
        Emit('push')
    ], PaymentCard.prototype, "cancel", null);
    PaymentCard = __decorate([
        Component({})
    ], PaymentCard);
    return PaymentCard;
}(Vue));
export default PaymentCard;
